<template>
  <div class="horizontal-line-chart-node">
    <ChartHeader
      v-if="!value.meta.minimalMode"
      :value="value"
      :display-chart="displayChart"
      @set-display-chart="setDisplayChart"
      @deletChart="$emit('deleteChart')"
    />
    <div class="horizontal-line-chart-container" style="overflow-x: auto">
      <svg
        v-show="displayChart"
        ref="chart"
        class="pigeondoc-chart"
        :class="
          !value.meta.minimalMode
            ? 'horizontal-line-chart-container'
            : 'horizontal-line-chart-container-minimal'
        "
      ></svg>
      <HorizontalLineChartTable :value="value" v-if="!displayChart && !value.meta.minimalMode" />
    </div>
  </div>
</template>

<script>
import ChartHeader from '../ChartHeader/ChartHeader.vue';
import HorizontalLineChartTable from './HorizontalLineChartTable.vue';
import horizontalLineChartMixin from './horizontalLineChartMixin.js';

export default {
  name: 'HorizontalLineChart',
  mixins: [horizontalLineChartMixin],
  components: {
    ChartHeader,
    HorizontalLineChartTable,
  },
  data() {
    return {
      displayChart: true,
    };
  },
  methods: {
    setDisplayChart(value) {
      this.displayChart = value;
    },
  },
};
</script>

<style>
.horizontal-line-chart-node {
  width: 100%;
}

/* margin: 4rem 0; */

.horizontal-line-chart-container {
  margin: 0;
}

.horizontal-line-chart-container svg {
  width: 100%;
}

.horizontal-line-chart-container-minimal {
  max-height: 10rem;
}
</style>
